import { MapViewType } from "./MapViewType";

export const getMapStyling = (mapType: MapViewType) => {
  if (mapType === MapViewType.SATELLITE) {
    return "mapbox://styles/mapbox/satellite-streets-v9";
  } else {
    return "https://api.maptiler.com/maps/streets/style.json?key=7NBCsLfJrAt6F93vbbFV";
  }
};
